export class FileUtilities {
    static removeExtension(fileName: string) {
        const lastIndexOfDot = fileName.lastIndexOf(".");
        if (lastIndexOfDot == 0) {
            return ""; // File name is untitled, e.g: ".txt"
        }

        return fileName.substring(0, lastIndexOfDot) || fileName;
    }

    static getExtension(fileName: string) {
        const lastIndexOfDot = fileName.lastIndexOf(".");
        if (lastIndexOfDot == 0) {
            return fileName; // File name is untitled, e.g: ".txt"
        }

        return fileName.substring(fileName.lastIndexOf("."), fileName.length) || "";
    }
}
